/* LYD sale calendar v3. Native banner and a rotating message inside the native announcement bar. */
(() => {
  'use strict';
  const node = document.getElementById('lyd-sale-config');
  if (!node || window.lydSaleCalendar) return;
  const config = JSON.parse(node.textContent);
  const schedule = config.schedule;
  const originalBadges = new WeakMap();
  const renderedBadgeText = new WeakMap();
  const changedBadges = new Set();
  const heroText = new Map();
  const heroLinks = new Map();
  const announcementStates = new Map();
  let current = null, timer, queued = false;
  let clockOffset = 0;
  const now = () => Date.now() + clockOffset;
  const select = (rows, time) => rows.find(row => time >= row.from && time < row.until) || null;
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const safeUrl = value => { const u = new URL(value, location.origin); return u.origin === location.origin ? u.pathname + u.search : config.root + 'collections/all'; };
  function paintNativeText(el, field) {
    let state = heroText.get(el);
    if (!state) {
      const walker = document.createTreeWalker(el,NodeFilter.SHOW_TEXT,{acceptNode:n =>
        n.nodeValue.trim() && !n.parentElement.closest('svg,script,style,[aria-hidden="true"]') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT});
      const texts = [];while(walker.nextNode()) texts.push({node:walker.currentNode,value:walker.currentNode.nodeValue});
      if (!texts.length) return;
      state = {texts,ariaLabel:el.getAttribute('aria-label')};heroText.set(el,state);
    }
    // Keep the theme's wrappers, animation elements, icons, fonts and styles intact.
    state.texts.forEach(({node},i) => { const value = i === 0 ? current[field] : '';if(node.nodeValue !== value) node.nodeValue = value; });
    if(state.ariaLabel !== null && el.getAttribute('aria-label') !== current[field]) el.setAttribute('aria-label',current[field]);
    el.dataset.lydHeroField = field;
  }
  function paintNativeLink(el) {
    if (!heroLinks.has(el)) heroLinks.set(el,el.getAttribute('href'));
    const href = safeUrl(current.url);if(el.getAttribute('href') !== href) el.setAttribute('href',href);
  }
  function heroes() {
    if (config.page !== 'index') return;
    if (!current) {
      heroText.forEach((state,el) => {
        state.texts.forEach(({node,value}) => {if(node.nodeValue !== value) node.nodeValue = value;});
        if(state.ariaLabel !== null) el.setAttribute('aria-label',state.ariaLabel);
        delete el.dataset.lydHeroField;
      });
      heroLinks.forEach((href,el) => {if(href === null) el.removeAttribute('href');else el.setAttribute('href',href);});
      heroText.clear();heroLinks.clear();return;
    }
    document.querySelectorAll(config.heroSelector).forEach(native => {
      Object.entries(config.heroFields || {}).forEach(([field,selector]) => {
        native.querySelectorAll(selector).forEach(el => {
          if(field !== 'url') paintNativeText(el,field);
          if(field === 'url' || field === 'cta') {const link = el.closest('a');if(link) paintNativeLink(link);}
        });
      });
    });
    for(const el of heroText.keys()) if(!el.isConnected) heroText.delete(el);
    for(const el of heroLinks.keys()) if(!el.isConnected) heroLinks.delete(el);
  }
  function stopAnnouncement(field,state,restore) {
    clearTimeout(state.timer);state.events.abort();
    if(restore && state.wrapper.parentElement === field) field.replaceChildren(...state.original.childNodes);
    announcementStates.delete(field);
  }
  function startAnnouncement(field) {
    const wrapper = document.createElement('span');wrapper.className = 'lyd-announcement-messages';wrapper.dataset.lydAnnouncementRotator = '';
    const original = document.createElement('span');original.className = 'lyd-announcement-original';
    // Preserve the merchant's existing text, links and formatting as the first message.
    original.append(...field.childNodes);
    const campaign = document.createElement('span');campaign.className = 'lyd-announcement-campaign';
    const link = document.createElement('a');link.className = 'lyd-sale-announcement';
    const text = document.createElement(config.announcementTextTag || 'span');text.className = config.announcementTextClass || '';
    link.append(text);campaign.append(link);wrapper.append(original,campaign);field.append(wrapper);
    const nativeSpeed = Number(field.closest('[autoplay]')?.getAttribute('autoplay')) * 1000;
    const state = {wrapper,original,campaign,link,text,events:new AbortController(),showingCampaign:false,hovered:false,focused:false,interval:nativeSpeed || config.announcementInterval || 5000};
    const show = campaignVisible => {
      state.showingCampaign = campaignVisible;
      [original,campaign].forEach((el,i) => {
        const visible = i === (campaignVisible ? 1 : 0);
        el.dataset.lydAnnouncementVisible = String(visible);el.setAttribute('aria-hidden',String(!visible));el.inert = !visible;
      });
    };
    const tick = () => {
      if(!field.isConnected) {stopAnnouncement(field,state,false);return;}
      const nativePaused = field.closest(config.announcementSelector)?.querySelector('.slideshow__pause.is-paused');
      if(!document.hidden && !state.hovered && !state.focused && !nativePaused) show(!state.showingCampaign);
      state.timer = setTimeout(tick,state.interval);
    };
    const options = {signal:state.events.signal};
    field.addEventListener('mouseenter',()=>{state.hovered=true;},options);
    field.addEventListener('mouseleave',()=>{state.hovered=false;},options);
    field.addEventListener('focusin',()=>{state.focused=true;},options);
    field.addEventListener('focusout',event=>{state.focused=field.contains(event.relatedTarget);},options);
    show(false);state.timer = setTimeout(tick,state.interval);announcementStates.set(field,state);return state;
  }
  function announcements() {
    for(const [field,state] of announcementStates) {
      if(!current || !field.isConnected || state.wrapper.parentElement !== field) stopAnnouncement(field,state,!!field.isConnected);
    }
    if(!current || !config.announcementMessageSelector) return;
    document.querySelectorAll(config.announcementSelector).forEach(section => {
      section.querySelectorAll(config.announcementMessageSelector).forEach(field => {
        const state = announcementStates.get(field) || startAnnouncement(field);
        if(state.link.dataset.campaign === current.id) return;
        state.text.innerHTML = `<span class="lyd-sale-announcement__desktop">${esc(current.announcement)}</span><span class="lyd-sale-announcement__mobile">${esc(current.headline)}</span>`;
        state.link.href = safeUrl(current.url);state.link.dataset.campaign = current.id;
      });
    });
  }
  function badges() {
    const selectors = config.badgeSelectors.join(',');
    if (!selectors) return;
    document.querySelectorAll(selectors).forEach(el => {
      if (!originalBadges.has(el) || (renderedBadgeText.has(el) && el.textContent.trim() !== renderedBadgeText.get(el))) originalBadges.set(el,el.innerHTML);
      if (el.classList.contains('lyd-sale-neutral-badge') !== !!current?.neutral) el.classList.toggle('lyd-sale-neutral-badge',!!current?.neutral);
      if (current && current.badge) {
        if (el.textContent.trim() !== current.badge) el.textContent = current.badge;
        el.setAttribute('data-lyd-badge-active','');changedBadges.add(el);
        renderedBadgeText.set(el,current.badge);
      } else if (changedBadges.has(el)) {
        el.innerHTML = originalBadges.get(el);el.removeAttribute('data-lyd-badge-active');changedBadges.delete(el);
        renderedBadgeText.delete(el);
      }
    });
    document.querySelectorAll('[data-lyd-extra-badge]').forEach(el => {
      const container = el.closest('[data-section-type="product"]');
      const price = container && container.querySelector('[data-product-price]');
      const buy = container && container.querySelector('[data-add-to-cart]');
      const eligible = price && price.classList.contains('on-sale') && buy && !buy.disabled;
      const visible = !!(current && current.badge && eligible);
      el.hidden = !visible;
      if (visible && el.textContent !== current.badge) el.textContent = current.badge;
    });
    for (const el of changedBadges) if (!el.isConnected) changedBadges.delete(el);
  }
  function refresh() {
    queued = false;
    const row = select(schedule,now());current = row;
    heroes();announcements();badges();
    document.documentElement.dataset.lydSalePhase = row ? row.phase : '';
    clearTimeout(timer);
    const boundary = schedule.flatMap(r=>[r.from,r.until]).find(t=>t>now());
    timer = setTimeout(refresh,boundary ? Math.max(20,Math.min(boundary-now()+20,60000)) : 60000);
  }
  function queue() { if (!queued) { queued = true;requestAnimationFrame(refresh); } }
  async function syncClock() {
    try {
      const start = Date.now();
      const response = await fetch(config.root + '?lyd_clock=' + start, {method:'HEAD',cache:'no-store',credentials:'same-origin',signal:AbortSignal.timeout(5000)});
      const server = Date.parse(response.headers.get('Date'));
      if (response.ok && Number.isFinite(server)) clockOffset = server + (Date.now()-start)/2 - Date.now();
    } catch (_) { /* Device clock remains a usable fallback. */ }
    refresh();
  }
  window.lydSaleCalendar = Object.freeze({version:config.version,get phase(){return current?.phase || null;},get country(){return config.country;},get locale(){return config.locale;}});
  const observer = new MutationObserver(records => {
    // Ignore our own nodes and attributes to avoid loops on busy product grids.
    if (records.some(r => {
      const el = r.target.nodeType === 1 ? r.target : r.target.parentElement;
      if (!el || el.closest('[data-lyd-announcement-rotator],.lyd-sale-announcement,[data-lyd-extra-badge]')) return false;
      const badge = el.closest('[data-lyd-badge-active]');
      return !badge || badge.textContent.trim() !== renderedBadgeText.get(badge);
    })) queue();
  });
  refresh();
  observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','disabled'],characterData:true});
  document.addEventListener('shopify:section:load',queue);
  document.addEventListener('variant:change',queue);
  document.addEventListener('variant:changed',queue);
  document.addEventListener('change',queue);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden){refresh();syncClock();}});
  window.addEventListener('pageshow',queue);
  syncClock();setInterval(syncClock,3600000);
})();
